import { useCallback, useContext, useEffect, useRef } from 'react';

import AuthContext from './authContext';

const useAuth = () => useContext(AuthContext);

export const useCurrentUser = () => useAuth()?.getCurrentUser();

export const useUserSecret = () => useCurrentUser()?.userSecret;

export const useUserEmail = () => useCurrentUser()?.email;

export default useAuth;
